import { Routes } from '@angular/router';
import { RolesGuard } from '@dss-libs/shared/guard/common-guards';
import { UserRole } from '@dss-libs/shared/type/common-types';

export const settingsRoutes: Routes = [
  {
    path: 'account-info',
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.AccountInfoComponent),
  },
  {
    path: 'user-management',
    canActivate: [RolesGuard],
    data: { authorizedRole: UserRole.Admin },
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.UserManagementComponent),
  },
  {
    path: 'manage-subscription',
    canActivate: [RolesGuard],
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.ManageSubscriptionsComponent),
    data: {
      authorizedRole: UserRole.Owner,
    },
  },
  {
    path: 'api-settings',
    canActivate: [RolesGuard],
    data: { authorizedRole: UserRole.Owner },
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.ApiSettingsComponent),
  },
  {
    path: 'branding',
    canActivate: [RolesGuard],
    data: { authorizedRole: UserRole.Admin },
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.BrandingComponent),
  },
  {
    path: 'order-settings',
    canActivate: [RolesGuard],
    data: { authorizedRole: UserRole.Admin },
    loadComponent: () => import('@dss-libs/portal/feature/settings').then((m) => m.OrderSettingsComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'account-info',
  },
  {
    path: '**',
    redirectTo: 'account-info',
  },
];
